import { useContext } from 'react';
import { KamiInput } from '@taxdown/piccolo-web';
import { KamiInputForm } from '@taxdown/piccolo-web/dist/components/KamiInput/types';
import { YayoyakiValue } from '@taxdown/kami-sama/dist/kamiSama';
import ReadonlyContext from 'Context/validations';
import * as Styled from '../../styles';

const DynamicForm = ({
  yayoyakis,
  onReloadYayos,
}: {
  yayoyakis: YayoyakiValue[];
  onReloadYayos: () => void;
}): JSX.Element => {
  const { onReadOnly, readOnly } = useContext(ReadonlyContext);
  const handleUpdate = index => value => {
    yayoyakis[index].setValue(value);
    onReloadYayos?.();
  };

  return (
    <>
      {yayoyakis.map((yayoyaki, index) => {
        const inputForm = yayoyaki.getRenderForm() as KamiInputForm;
        const yayoyakiId = yayoyaki.getId();
        if (!inputForm) {
          return null;
        }
        return (
          <Styled.InputContainer key={yayoyakiId}>
            {readOnly && <Styled.ReadOnlyView data-testid="readOnlyLayer" onClick={onReadOnly} />}
            <KamiInput id={yayoyakiId} inputForm={inputForm} onChange={handleUpdate(index)} />
          </Styled.InputContainer>
        );
      })}
    </>
  );
};

export default DynamicForm;
